import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useRecoilValue } from "recoil";
import styled from "styled-components";
import { langState, langText } from "../../recoil/lang";
import "../../styles/CustomModal.css";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import ApiController from "../../controller/ApiController";
import { qrAuthState } from "../../recoil/auth";
import { cardType } from "../../controller/OrderController";

const CardListModal = (oProps: {
  isVisible: boolean;
  setVisible: any;
  openAddCardModal: any;
  cardList: UseQueryResult<cardType[]>;
  selectedCard: number;
  setSelectedCard: (selectedCard: number) => void;
  onPay: any;
}) => {
  const auth = useRecoilValue(qrAuthState);
  const lang = useRecoilValue(langState);

  const onCloseModal = () => {
    oProps.setVisible(false);
  };

  return (
    <Modal
      isOpen={oProps.isVisible}
      onRequestClose={onCloseModal}
      className="languageModal modal-content bottom"
      closeTimeoutMS={100}
      ariaHideApp={false}
    >
      <Style>
        <div className="modal">
          <div className="modal_header">
            <h6>{langText.cardListModal_title[lang]}</h6>
            <img
              className="closeIcon"
              onClick={onCloseModal}
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
              alt="ic"
            />
          </div>
          <div className="modal_content">
            {oProps.cardList.data && oProps.cardList.data.length > 0 ? (
              <>
                {oProps.cardList.data.map((item: cardType, index: number) => (
                  <div
                    key={index}
                    className={`cardItem ${
                      oProps.selectedCard === index && "active"
                    }`}
                    onClick={() =>
                      oProps.selectedCard === -1
                        ? oProps.setSelectedCard(index)
                        : oProps.setSelectedCard(-1)
                    }
                  >
                    <h4>{item.card_name}</h4>
                    <h4>{item.card_no}</h4>
                    <div className="checkIcon">
                      {oProps.selectedCard === index ? (
                        <img
                          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_check_circle_green.svg`}
                          alt="check"
                        />
                      ) : (
                        <button>
                          <p>{langText.delete[lang]}</p>
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div className="cardItem none">
                <h4>{langText.cardListModal_comment_none[lang]} 😊</h4>
              </div>
            )}
          </div>
          <button className="addButton" onClick={oProps.openAddCardModal}>
            <img
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_plus_white.svg`}
              alt="plus"
            />
            {langText.cardListModal_button_add[lang]}
          </button>
          <button className="submitButton" onClick={oProps.onPay}>
            {langText.cardListModal_button_complete[lang]}
          </button>
        </div>
      </Style>
    </Modal>
  );
};

export default CardListModal;

const Style = styled.div`
  .modal {
    padding: 24px 10px;
    padding-bottom: 40px;
    position: relative;
  }

  .modal_header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    h6 {
      font-size: 20px;
      line-height: 30px;
      font-weight: 500;
      color: #ffffff;
    }
    .closeIcon {
      position: absolute;
      width: 24px;
      right: 12px;
      top: 12px;
    }
  }
  .modal_content {
    padding: 20px 0;
    width: 100%;
    max-height: 50dvh;
    overflow-y: auto;
    .cardItem {
      display: flex;
      align-items: center;
      padding: 16px 20px;
      justify-content: space-between;
      gap: 10px;
      border: 1px solid #a7a7a7;
      border-radius: 10px;
      margin-bottom: 10px;
      h4 {
        font-size: 16px;
        line-height: 22px;
        font-weight: 500;
      }
      .checkIcon {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 50px;
        height: 32px;
        img {
          height: 100%;
        }
        button {
          width: 100%;
          border: 1px solid #a7a7a7;
          text-align: center;
          padding: 4px 0;
          border-radius: 5px;
          p {
            font-size: 12px;
            line-height: 16px;
            font-weight: 500;
          }
        }
      }
    }
    .cardItem.active {
      padding: 14px 18px;
      border: 3px solid #4dd2ae;
    }

    .cardItem.none {
      border: none;
      height: 15dvh;
      text-align: center;
      justify-content: center;
      h4 {
        font-size: 14px;
        line-height: 20px;
        color: #4dd2ae;
        white-space: pre-line;
      }
    }
  }
  .addButton {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    width: 100%;
    padding: 9px 0;
    background: #343434;
    border: 1px solid #a7a7a7;
    border-radius: 50px;
    color: #ffffff;
    font-size: 16px;
    line-height: 22px;
    font-weight: 500;
    margin-bottom: 18px;
  }
  .submitButton {
    width: 100%;
    padding: 12px 0;
    background: #4dd2ae;
    border-radius: 10px;
    color: #ffffff;
    font-size: 20px;
    line-height: 30px;
    font-weight: 600;
  }
`;
